import { Col, Form, Row, Typography } from "antd";
import FormInput from "components/FormInput";
import {
  CAMPAIGN_TYPE,
  SELLER_USER_SEGMENT_TYPE,
  TYPE_LIMIT,
  isProductPromoProgramBudgetRequired,
  PRODUCT_PROMO_TARGET_CUSTOMER_OPTIONS,
} from "features/Campaign/constants";
import { useGetSellerUserSegments } from "hooks/seller";
import { t } from "i18next";
import { useEffect } from "react";
import { getQuery } from "utils/helperFuncs";
import { INPUT_TYPE } from "config/constants";
import {
  applyUnlimitedPurchaseLimitToProductPromoTiers,
  getSellerSegmentIDByType,
} from "features/Campaign/utils/productPromoTargetCustomer";

const ProductPromoCommonInfoFields = ({ form }) => {
  const GET_QUERY = getQuery();
  const isProductPromo = GET_QUERY.campaignType === CAMPAIGN_TYPE.PRODUCT_PROMO;
  const { data: sellerUserSegments } = useGetSellerUserSegments();

  useEffect(() => {
    if (!isProductPromo || !sellerUserSegments?.length) {
      return;
    }

    const currentType = form.getFieldValue("sellerSegmentType");
    if (!currentType) {
      return;
    }

    const sellerSegmentID = getSellerSegmentIDByType(sellerUserSegments, currentType);
    if (sellerSegmentID && form.getFieldValue("sellerSegmentID") !== sellerSegmentID) {
      form.setFieldsValue({ sellerSegmentID });
    }
  }, [form, isProductPromo, sellerUserSegments]);

  const handleTargetCustomerChange = (segmentType) => {
    const sellerSegmentID = getSellerSegmentIDByType(sellerUserSegments, segmentType);
    console.log("[DEBUG] handleTargetCustomerChange", { segmentType, sellerSegmentID }); // eslint-disable-line
    const nextValues = {
      sellerSegmentType: segmentType,
      sellerSegmentID,
    };

    if (!isProductPromoProgramBudgetRequired(segmentType)) {
      nextValues.maxBudgetPerSeller = undefined;
    }

    const promotionCampaignTierGroupsProductPromo = form.getFieldValue("promotionCampaignTierGroupsProductPromo");

    if (isProductPromoProgramBudgetRequired(segmentType)) {
      nextValues.promotionCampaignTierGroupsProductPromo = applyUnlimitedPurchaseLimitToProductPromoTiers(
        promotionCampaignTierGroupsProductPromo
      );
    } else if (segmentType === SELLER_USER_SEGMENT_TYPE.ALL && promotionCampaignTierGroupsProductPromo?.length) {
      const nextGroups = promotionCampaignTierGroupsProductPromo.map((group) => ({
        ...group,
        promotionCampaignTiers: group?.promotionCampaignTiers?.map((tier) => ({
          ...tier,
          limitType: TYPE_LIMIT.LIMIT,
        })),
      }));
      nextValues.promotionCampaignTierGroupsProductPromo = nextGroups;
    }

    form.setFieldsValue(nextValues);
  };

  if (!isProductPromo) {
    return null;
  }

  return (
    <>
      <Form.Item name="sellerSegmentID" hidden />
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormInput
            type={INPUT_TYPE.SELECT}
            formItemOptions={{
              label: <Typography.Text strong>{t("campaign.form.targetCustomer")}</Typography.Text>,
              name: "sellerSegmentType",
              rules: [
                {
                  required: true,
                  message: t("common.messageRequiredSelect", { message: t("campaign.form.targetCustomer") }),
                },
              ],
            }}
            inputOptions={{
              placeholder: t("campaign.form.targetCustomerPlaceholder"),
              options: PRODUCT_PROMO_TARGET_CUSTOMER_OPTIONS,
              onChange: handleTargetCustomerChange,
            }}
          />
        </Col>
        <Col span={24}>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.sellerSegmentType !== currentValues.sellerSegmentType
            }
          >
            {({ getFieldValue }) => {
              const sellerSegmentType = getFieldValue("sellerSegmentType");

              if (!isProductPromoProgramBudgetRequired(sellerSegmentType)) {
                return <div className="product-promo-budget-placeholder" aria-hidden="true" />;
              }

              return (
                <FormInput
                  type={INPUT_TYPE.CURRENCY_INPUT}
                  formItemOptions={{
                    label: <Typography.Text strong>{t("campaign.form.programBudget")}</Typography.Text>,
                    name: "maxBudgetPerSeller",
                    rules: [
                      {
                        required: true,
                        message: t("common.messageRequiredType", { message: t("campaign.form.programBudget") }),
                      },
                      {
                        type: "number",
                        min: 1,
                        message: t("campaign.combo.errorMessage.valueMustBeThan0"),
                      },
                    ],
                  }}
                  inputOptions={{
                    placeholder: t("campaign.form.programBudgetPlaceholder"),
                    maxLength: 13, // 10 số + 3 dấu chấm phân cách (BA: Maxlength 10 chữ số)
                  }}
                />
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default ProductPromoCommonInfoFields;
